module.exports = __webpack_public_path__ + "static/media/feature-tile-icon-04.682d5108.svg";